import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion'; // Importation de framer-motion
import LogoCM from '../../img/LogoCM.png';

import { useTranslation } from 'react-i18next';

function CardClub() {
  const [data, setData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');

  const { t, i18n } = useTranslation();

  useEffect(() => {
    axios.get('https://www.clublfit.org/api/data')
      .then(response => {
        const transformedData = response.data.map(item => {
          let logoUrl;

          if (item.Logo_Club && item.Logo_Club.data) {
            try {
              const logoBlob = new Blob([Uint8Array.from(item.Logo_Club.data)], { type: 'image/png' });
              logoUrl = URL.createObjectURL(logoBlob);
            } catch (error) {
              console.error('Error creating blob for logo:', error);
              logoUrl = LogoCM;
            }
          } else {
            logoUrl = LogoCM;
          }

          return { ...item, logoUrl };
        });
        transformedData.sort((a, b) => a.Nom_Club.localeCompare(b.Nom_Club));
        setData(transformedData);
      })
      .catch(error => console.error('Erreur lors de la récupération des données', error));
  }, []);

  const filteredData = data.filter(row => {
    const matchesCategory = selectedCategory === 'All' || row.Categorie_Club === selectedCategory;
    const matchesSearch = row.Nom_Club.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  // Variants pour l'animation
  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
    hover: { scale: 1.05 },
  };

  return (
    <div className="container">
      <div className="col-lg-12 col-md-6 mb-30 text-center">
        <h2 className="display-4 mb-4">{t('Liste_clubs')}</h2>

        <ul id="filters" className="list-inline filter1 d-inline-block text-center mb-4">
          <li className="list-inline-item px-2">
            <span
              className={`filter ${selectedCategory === 'All' ? 'active' : ''}`}
              onClick={() => setSelectedCategory('All')}
            >
              {t('Tous')}
            </span>
          </li>

          {Array.from(new Set(data.map(row => row.Categorie_Club))).map(categorie => (
            <li className="list-inline-item px-2" key={categorie}>
              <span
                className={`filter ${selectedCategory === categorie ? 'active' : ''}`}
                onClick={() => setSelectedCategory(categorie)}
              >
                {categorie}
              </span>
            </li>
          ))}
        </ul>

        <input
          type="text"
          placeholder={t('Rechercher_club')}
          className="form-control mb-4 mt-2 w-50 mx-auto"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="row ">
        {filteredData.map(row => (
          <motion.div
            className="col-lg-4 col-md-6 mb-4"
            key={row.Id_Club}
            variants={cardVariants} // Application des variants
            initial="hidden"
            animate="visible"
            whileHover="hover" // Animation au survol
            transition={{ duration: 0.3 }} // Durée de l'animation
          >
            <div className="card h-100 shadow-sm">
              <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: '200px', border: '2px solid #007bff', overflow: 'hidden', backgroundColor: '#f8f9fa', borderRadius: '10px' }}>
                <img src={row.logoUrl} alt="Logo Club" style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: '10px' }} className="p-3" />
              </div>
              <div className="card-body d-flex flex-column">
                <h5 className="card-title text-center text-primary"><strong>{row.Nom_Club}</strong></h5>
                <p className="card-text text-muted text-truncate-3" style={{ flexGrow: 1 }}>
                  {row.Description_Club}
                </p>
                <div className="mt-auto text-center">
                  <Link to={`/clubs/${row.Id_Club}`} className="btn btn-gradient-primary btn-block text-white shadow-sm " style={{ backgroundImage: 'linear-gradient(to right, #6a11cb, #2575fc)', border: 'none' }}>{t('savoir_plus')}</Link>
                </div>
              </div>
              <div className="card-footer text-muted text-center">
                <a href={`mailto:${row.Mail_Club}`} className="text-decoration-none">{row.Mail_Club}</a>
              </div>
            </div>
          </motion.div>
        ))}
        {filteredData.length === 0 && (
          <div className="col-12 text-center">
            <p className="text-muted">{t('Pas_de_correspondance')}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default CardClub;
